import { graphql, Script, withPrefix } from "gatsby";
import React from "react";

import type { CampaignWizardDataFragment } from "../../../graphql-types";

import "./campaign-wizard.css";

type Props = CampaignWizardDataFragment;

export default function CampaignWizard({ campaignId, successPageSlug }: Props) {
  return (
    <div className="relative px-6 mb-8 bg-white max-w-md mx-auto form-wrapper">
      <Script
        src="https://forms-widget.unileversolutions.com/widget.js"
        strategy="idle"
      />
      <div
        className="form-widget"
        data-testid="campaign-wizard"
        data-form-id={campaignId}
        data-success-page={withPrefix(
          `${successPageSlug}.html`.replace(/^\//, "")
        )}
      />
    </div>
  );
}

export function CampaignWizardHead() {
  return (
    <link
      rel="stylesheet"
      href="https://forms-widget.unileversolutions.com/widget.css"
    />
  );
}

export const fragment = graphql`
  fragment CampaignWizardData on CampaignWizard {
    campaignId
    successPageSlug
  }
`;
